import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { heroData } from '../../data/mockData';

export const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[rgb(17,17,19)]">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/7195308/pexels-photo-7195308.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Healthcare digital marketing consultation"
          className="w-full h-full object-cover opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[rgb(17,17,19)] via-[rgba(17,17,19,0.85)] to-[rgb(17,17,19)]" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 lg:px-8 relative z-10 pt-32 pb-24">
        <div className="max-w-5xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-[rgba(0,250,99,0.1)] border border-[rgba(0,250,99,0.3)] rounded-full px-6 py-3 mb-10 animate-fade-in">
            <span className="w-2 h-2 bg-[rgb(0,250,99)] rounded-full animate-pulse" />
            <span className="text-[rgb(0,250,99)] text-sm font-medium">
              Healthcare Marketing Experts
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-10 leading-[1.1] animate-slide-in-left">
            {heroData.tagline}
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl lg:text-3xl text-[rgb(218,218,218)] mb-14 max-w-3xl mx-auto leading-relaxed animate-slide-in-right">
            {heroData.subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-24 animate-scale-in">
            <Link
              to={heroData.ctaLink}
              className="group px-10 py-5 bg-[rgb(0,250,99)] text-[rgb(17,17,19)] rounded-xl font-semibold text-lg hover:bg-[rgb(0,220,87)] transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_12px_30px_rgba(0,250,99,0.5)] flex items-center space-x-3"
            >
              <span>{heroData.ctaText}</span>
              <ArrowRight size={20} className="group-hover:translate-x-2 transition-transform duration-300" />
            </Link>
            <Link
              to="/services"
              className="px-10 py-5 bg-transparent text-white rounded-xl font-semibold text-lg border-2 border-[rgb(63,63,63)] hover:border-[rgb(0,250,99)] hover:text-[rgb(0,250,99)] hover:bg-[rgba(0,250,99,0.1)] transition-all duration-300 hover:-translate-y-2"
            >
              Explore Our Solutions
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12 max-w-4xl mx-auto animate-fade-in">
            {[
              { value: '50+', label: 'Healthcare Brands' },
              { value: '₹50L+', label: 'Revenue Generated' },
              { value: '5+', label: 'Years Experience' },
              { value: '98%', label: 'Client Satisfaction' }
            ].map((stat, index) => (
              <div key={index} className="text-center transform hover:scale-110 transition-transform duration-300">
                <div className="text-4xl md:text-5xl font-bold text-[rgb(0,250,99)] mb-3">
                  {stat.value}
                </div>
                <div className="text-sm md:text-base text-[rgb(161,161,170)]">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-[rgb(0,250,99)] rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-2.5 bg-[rgb(0,250,99)] rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  );
};
